import React, { useState } from "react";
import styles from "./index.module.css";
import { Link, useNavigate } from "react-router-dom";
import Wrapper from "../../components/UI/wrapper";
import { BackArrow } from "../../icons";
import registrationCheck from "../../api/registrationCheck";
import Loading from "../../components/loading";

const SuccessMessage = <div>
  <p>Hörmətli iştirakçı</p>
  <br />
  <p>
    Uşaq İncəsənət Festivalında iştirak etdiyiniz üçün təşəkkür edirik!
    Siz tələb olunan keçid balını toplayaraq festivalın final mərhələsində iştirak etmək hüququ qazanmısınız. Final mərhələsinin məkan və tarixi barədə əlavə məlumat veriləcəkdir. Uğurlar arzu edirik!
  </p>
</div>

const FailedMessage = <div>
  <p>Hörmətli iştirakçı</p>
  <br />
  <p>
    Uşaq İncəsənət Festivalında iştirak etdiyiniz üçün təşəkkür edirik!
    Təəssüf ki, Siz ikinci mərhələ üzrə yekun qiymətləndirmənin nəticələrinə uyğun olaraq festivalın final mərhələsinə keçə bilməmisiniz. Növbəti festivallarımızda yenidən görüşmək ümidi ilə Sizə uğurlar arzu edirik!
  </p>
</div>

const RegistrationCheck = () => {
  const [regType, setRegType] = useState(1);
  const [personalRegType, setPersonalRegType] = useState(null);
  const [personalInput, setPersonalInput] = useState(null);
  const [collectiveRegType, setCollectiveRegType] = useState(null);
  const [collectiveInput, setCollectiveInput] = useState(null);
  const [response, setResponse] = useState(null);
  const [responseText, setResponseText] = useState(null);
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const [user, setUser] = useState(null)

  // 2ci merhele neticesini mueyyen etmek ucun state (1- ugurlu, 2-ugursuz)
  const [resultType, setResultType] = useState(null)

  const handlePersonalRegType = (e) => {
    setPersonalRegType(e.target.value);
  };
  const handlePersonalInput = (e) => {
    setPersonalInput(e.target.value);
  };
  const handleCollectiveRegType = (e) => {
    setCollectiveRegType(e.target.value);
  };
  const handleCollectiveInput = (e) => {
    setCollectiveInput(e.target.value);
  };
  const getPersonalPlaceholder = () => {
    if (personalRegType === "fin") return "Fin kod";
    if (personalRegType === "birth") return "Doğum haqqında şəhadətnamə";
    if (personalRegType === "id") return "Qeydiyyat kodu";
    return "";
  };
  const getCollectivePlaceholder = () => {
    if (collectiveRegType === "fin") return "Fin kod";
    if (collectiveRegType === "id") return "Qeydiyyat kodu";
    return "";
  };

  async function getResult() {
    setResponseText(null);
    const query = {
      type: regType === 1 ? "personal" : "collective",
      document: personalRegType ? personalRegType : collectiveRegType,
      value: personalInput ? personalInput : collectiveInput,
    };
    if (regType === 1) {
      setLoading(true)
      const data = await registrationCheck
        .personalFinalResult(query)
        .then((response) => {
          const user = response.data;
          setUser(user)
          setResultType(user.qalibi_yoxla)
          if (
            response.data.message === "Məlumat tapılmadı!" ||
            response.data.message === "Səhv sorğu !!!"
          ) {
            setResponse(response.data.message);
          } else {
            setResponse("");
            setResponseText(
              ""
            );
            // sessionStorage.setItem("userData", JSON.stringify(user));
            // navigate('/registration-check-details')
          }
        })
        .catch((error) => {
          console.log(error);
        }).finally(() => setLoading(false));
    } else {
      setLoading(true)
      const data = await registrationCheck
        .collectiveFinalResult(query)
        .then((response) => {
          const user = response.data
          setUser(user)
          setResultType(user.qalibi_yoxla)
          if (
            response.data.message === "Məlumat tapılmadı!" ||
            response.data.message === "Səhv sorğu !!!"
          ) {
            setResponse(response.data.message);
          } else {
            setResponse("");
            setResponseText(
              ""
            );
            // sessionStorage.setItem("userData", JSON.stringify(user));
            // navigate('/registration-check-details')
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => setLoading(false));
    }
  }

  async function getReg() {
    setResponseText(null);
    const query = {
      type: regType === 1 ? "personal" : "collective",
      document: personalRegType ? personalRegType : collectiveRegType,
      value: personalInput ? personalInput : collectiveInput,
    };
    if (regType === 1) {
      const data = await registrationCheck
        .getTimePlacePersonal(query)
        .then((response) => {
          const user = response.data
          console.log(response)
          if (
            response.data.message === "Məlumat tapılmadı!" ||
            response.data.message === "Səhv sorğu !!!"
          ) {
            setResponse(response.data.message);
          } else {
            setResponse("Qeydiyyat kodunuz: " + response.data.message);
            setResponseText(
              "Daxil etdiyiniz məlumata əsasən qeydiyyat uğurla tamamlanmışdır."
            );
            sessionStorage.setItem("userData", JSON.stringify(user));
            navigate('/registration-check-details')
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      const data = await registrationCheck
        .getTimePlaceCollective(query)
        .then((response) => {
          const user = response.data
          if (
            response.data.message === "Məlumat tapılmadı!" ||
            response.data.message === "Səhv sorğu !!!"
          ) {
            setResponse(response.data.message);
          } else {
            setResponse("Qeydiyyat kodunuz: " + response.data.message);
            setResponseText(
              "Daxil etdiyiniz məlumata əsasən qeydiyyat uğurla tamamlanmışdır."
            );
            sessionStorage.setItem("userData", JSON.stringify(user));
            navigate('/registration-check-details')
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  return (
    <>
      {loading && <Loading />}
      <Wrapper>
        <Link to={"/"} className={styles["go-back"]}>
          <BackArrow />
          <p>Geri qayıt</p>
        </Link>
      </Wrapper>
      <Wrapper>
        <div className={styles["done-container"]}>
          <div className={styles["done"]}>
            <h3>Nəticəni yoxla</h3>
            <div>
              <button
                className={
                  styles[
                  `${regType == 1 ? "tab-buttons-active" : "tab-buttons"}`
                  ]
                }
                onClick={() => {
                  setRegType(1);
                  setCollectiveInput("");
                  setCollectiveRegType("");
                  setPersonalInput("");
                  setPersonalRegType("");
                  setResultType(null)
                }}
              >
                Fərdi
              </button>
              <button
                className={
                  styles[
                  `${regType == 2 ? "tab-buttons-active" : "tab-buttons"}`
                  ]
                }
                onClick={() => {
                  setRegType(2);
                  setPersonalInput("");
                  setPersonalRegType("");
                  setCollectiveInput("");
                  setCollectiveRegType("");
                  setResultType(null)
                }}
              >
                Kollektiv
              </button>
            </div>
            {regType == 1 ? (
              <>
                <div className={styles["inputs"]}>
                  <label htmlFor="">Qeydiyyatın tipi</label>
                  <select
                    name=""
                    id=""
                    onChange={(e) => handlePersonalRegType(e)}
                    value={personalRegType}
                  >
                    <option value="" disabled selected>
                      Qeydiyyatın tipi
                    </option>
                    <option value="fin_code">İştirakçının fin kodu</option>
                    {/* <option value="birth_card">
                      İştirakçının doğum haqqında şəhadətnaməsi
                    </option> */}
                    <option value="id_code">İştirakçının qeydiyyat kodu</option>
                  </select>
                </div>
                <div className={styles["inputs"]}>
                  <input
                    type={personalRegType === "id" ? "number" : "text"}
                    placeholder={getPersonalPlaceholder()}
                    onChange={(e) => handlePersonalInput(e)}
                    disabled={personalRegType ? false : true}
                    value={personalInput}
                  />
                </div>
              </>
            ) : (
              <>
                <div className={styles["inputs"]}>
                  <label htmlFor="">Qeydiyyatın tipi</label>
                  <select
                    name=""
                    id=""
                    onChange={(e) => handleCollectiveRegType(e)}
                    value={collectiveRegType}
                  >
                    <option value="" disabled selected>
                      Qeydiyyatın tipi
                    </option>
                    <option value="col_fin_code">
                      Kollektiv rəhbərinin fin kodu
                    </option>
                    <option value="col_id_code">
                      Kollektivin qeydiyyat kodu
                    </option>
                  </select>
                </div>
                <div className={styles["inputs"]}>
                  <input
                    type={collectiveRegType === "id" ? "number" : "text"}
                    placeholder={getCollectivePlaceholder()}
                    onChange={(e) => handleCollectiveInput(e)}
                    disabled={collectiveRegType ? false : true}
                    value={collectiveInput}
                  />
                </div>
              </>
            )}
            <div className={styles["next-container"]}>
              <button
                type="button"
                className={styles["next"]}
                onClick={() => getResult()}
              >
                Yoxla
              </button>
            </div>
            {resultType == 1 && (regType == 1 ?
              <>
                <p>Hörmətli <b>{user?.ad_soyad}</b>!</p>
                <br />
                <p>
                  Ölkəmizin ən genişmiqyaslı uşaq yaradıcılıq platformasına çevrilmiş  "Uşaq İncəsənət Festivalı 2025" də iştirak etdiyiniz üçün sizə təşəkkür edirik!
                  Siz, final mərhələsi üzrə yekun qiymətləndirmənin nəticələrinə uyğun olaraq <b>{user?.yas_kateqoriyasi}</b> yaş qrupunda <b>{user?.nominasiya}</b> nominasiyası üzrə <b>{user?.bacariq_seviyyesi}</b> kateqoriyasında <b>{user?.yer}</b> yerə layiq görülmüsünüz.
                </p>
                <p>Əlamətdar qələbəniz münasibəti ilə sizi ürəkdən təbrik edirik! Qoy bu qələbə daha çox zəfərlər qazanmaq üçün Sizə uğur gətirsin.
                  Ən xoş arzularla,</p>
                <p style={{ textAlign: 'start', width: '100%' }}>
                  <span>Uşaq İncəsənət Festivalının</span>
                  <br />
                  <span>Təşkilat Komitəsi</span>
                </p>
              </> :
              <>
                <p>Hörmətli <b>{user?.kollektivin_adi}</b> kollektivi!</p>
                <br />
                <p>
                  Ölkəmizin ən genişmiqyaslı uşaq yaradıcılıq platformasına çevrilmiş  "Uşaq İncəsənət Festivalı 2025" də iştirak etdiyiniz üçün sizə təşəkkür edirik!
                  Siz, final mərhələsi üzrə yekun qiymətləndirmənin nəticələrinə uyğun olaraq <b>{user?.yas_kateqoriyasi}</b> yaş qrupunda <b>{user?.nominasiya}</b> nominasiyası üzrə <b>{user?.yer}</b> yerə layiq görülmüsünüz. Əlamətdar qələbəniz münasibəti ilə sizi ürəkdən təbrik edirik! Qoy bu qələbə daha çox zəfərlər qazanmaq üçün Sizə uğur gətirsin.
                  Ən xoş arzularla,
                </p>
                <p style={{ textAlign: 'start', width: '100%' }}>
                  <span>Uşaq İncəsənət Festivalının</span>
                  <br />
                  <span>Təşkilat Komitəsi</span>
                </p>
              </>
            )
            }
            {resultType == 0 && (regType == 1 ?
              <>
                <p>Hörmətli iştirakçı!</p>
                <br />
                <p>
                  Ölkəmizin ən genişmiqyaslı uşaq yaradıcılıq platformasına çevrilmiş  "Uşaq İncəsənət Festivalı 2025" də iştirak etdiyiniz üçün sizə təşəkkür edirik!
                  Təəssüf ki, Siz "Final mərhələ"si üzrə yekun qiymətləndirmənin nəticələrinə uyğun olaraq bu mərhələdən keçə bilməmisiniz. Əziz iştirakçı, minlərlə iştirakçı arasından finala qədər yüksəlmək özü böyük bir nailiyyətdir! Növbəti festivallarımızda yenidən görüşmək ümidi ilə sizə uğurlar arzu edirik!
                  Ən xoş arzularla,
                </p>
                <p style={{ textAlign: 'start', width: '100%' }}>
                  <span>Uşaq İncəsənət Festivalının</span>
                  <br />
                  <span>Təşkilat Komitəsi</span>
                </p>
              </> :
              <>
                <p>Hörmətli Kollektiv!</p>
                <br />
                <p>
                  Ölkəmizin ən genişmiqyaslı uşaq yaradıcılıq platformasına çevrilmiş  "Uşaq İncəsənət Festivalı 2025" də iştirak etdiyiniz üçün sizə təşəkkür edirik!
                  Təəssüf ki, Siz "Final mərhələ"si üzrə yekun qiymətləndirmənin nəticələrinə uyğun olaraq bu mərhələdən keçə bilməmisiniz. Əziz kollektiv üzvləri, minlərlə iştirakçı arasından finala qədər yüksəlmək özü böyük bir nailiyyətdir! Növbəti festivallarımızda yenidən görüşmək ümidi ilə sizə uğurlar arzu edirik!
                  Ən xoş arzularla,
                </p>
                <p style={{ textAlign: 'start', width: '100%' }}>
                  <span>Uşaq İncəsənət Festivalının</span>
                  <br />
                  <span>Təşkilat Komitəsi</span>
                </p>
              </>
            )}
            {response ? (
              <>
                {responseText ? <h3>{responseText}</h3> : null}
                <h3>{response}</h3>
              </>
            ) : null}
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default RegistrationCheck;
